import { withStyles } from "@material-ui/core/styles";
import { fetchConfig } from "js/react/views/icons/actions/icons_actions";
import Nav from "js/react/views/Nav/Nav";
import React, { Component } from "react";
import { connect } from "react-redux";
import { updateTheme } from "./actions/themeEditor_actions";
import Decoration from "./components/Decoration";
import Footer from "./components/Footer";
import ThemeColors from "./components/ThemeColors";
import Typography from "./components/Typography";
import { indexStyle } from "./themeEditor_style";

class ThemeEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: "ThemeEditor",
            colors: <ThemeColors />,
            typography: <Typography {...this.props} />,
            decoration: <Decoration />,
            footer: <Footer />
        };
        this.showDefaultThemes = this.showDefaultThemes.bind(this);
    }

    componentDidMount() {
        !this.props.icons.baseUrl && this.props.fetchConfig();
    }

    showDefaultThemes() {
        this.props.loadTheme();
    }

    render() {
        let { classes, Navigation } = this.props;
        const navItems = [
            { label: "Colors", icon: "color_lens", value: "colors" },
            { label: "Typography", icon: "format_size", value: "typography" },
            { label: "Decoration", icon: "gradient", value: "decoration" },
            { label: "Footer", icon: "video_label", value: "footer" }
        ];

        return (
            <div className={classes.parent}>
                <div className={classes.themeOptionsContainer}>
                    <div className={classes.navParent}>
                        <Nav
                            items={navItems}
                            bottomItems={[]}
                            view={this.state.view}
                            defaultSelection={"colors"}
                            rootStyle={classes.topNav}
                        />
                    </div>
                    <div className={classes.content}>
                        {Navigation[this.state.view] &&
                            Navigation[this.state.view].selected === "colors" &&
                            this.state.colors}
                        {Navigation[this.state.view] &&
                            Navigation[this.state.view].selected ===
                                "typography" &&
                            this.state.typography}
                        {Navigation[this.state.view] &&
                            Navigation[this.state.view].selected ===
                                "decoration" &&
                            this.state.decoration}
                        {Navigation[this.state.view] &&
                            Navigation[this.state.view].selected === "footer" &&
                            this.state.footer}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ navigation, icons }) {
    return {
        Navigation: navigation,
        icons: icons.config
    };
}

export default connect(
    mapStateToProps,
    { updateTheme, fetchConfig }
)(withStyles(indexStyle)(ThemeEditor));
